import React from "react";
import { useEffect } from "react";
import { useTable, usePagination } from "react-table";
import { ButtonA, ButtonPagination } from "../../styles-components/Buttons";
import { Table } from "../../styles-components/Table";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import UseRedirectView from "../../utils/UseRedirectView";
import { BsFillTrashFill, BsPencilSquare, BsSearch } from "react-icons/bs";
// const route = process.env.MIX_APP_ROUTE;
// const route = process.env.MIX_APP_URL;

const TablePaginationTotal = ({
  orders,
  service,
  type,
  onDestroy,
  handleOpenModal,
}) => {
  // const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: service,
        columns: [
          {
            Header: "DATA",
            accessor: "date",
          },
          {
            Header: "TOTAL",
            accessor: "total",
          },
          {
            Header: "OBSERVAÇÕES",
            accessor: "note",
          },
          ,
        ],
      },
    ],
    []
  );

  const tableRef = useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: orders,
      initialState: { pageIndex: 0, pageSize: 15 },
    },
    usePagination
  );

  return (
    <>
      <Table ref={tableRef} {...getTableProps()} type={type}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>

      <div>
        {/* <ButtonPagination onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </ButtonPagination> */}
        <ButtonPagination
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <IoIosArrowBack />
        </ButtonPagination>
        <ButtonPagination
          onClick={() => {
            tableRef.current.focus();
            nextPage();
          }}
          disabled={!canNextPage}
        >
          <IoIosArrowForward />
        </ButtonPagination>
        {/* <ButtonPagination onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </ButtonPagination> */}
      </div>
    </>
  );
};

export default TablePaginationTotal;
